export enum AuthType {
  LOCAL = 'LOCAL',
}
